import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetDataService } from '../../services/getdata.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-lab-shipment',
  templateUrl: './lab-shipment.component.html',
  styleUrls: ['./lab-shipment.component.css']
})
export class LabShipmentComponent implements OnInit {

  shipmentDetails:{status:string,id:string,location:string,dateOfCreation:string,shipmentTo:string,courierName:string,
    trackingNo:string,details:{sampleType:string,quantity:number,sampleIds:string}[]}= {
      status:'',
      id:'',
      location:'',
      dateOfCreation:'',
      shipmentTo:'',
      courierName:'',
      trackingNo:'',
      details:[]
    };
  
  
  constructor(private activatedRoute:ActivatedRoute,private dataService:GetDataService,private ngxservice:NgxUiLoaderService) { 
    this.activatedRoute.queryParams.subscribe(response=>{
      if(response && response.id){
        this.getShipmentDetailsById(response.id);
      }
    })
  }

  ngOnInit(): void {
  }

  getShipmentDetailsById=(id:string)=>{
    this.ngxservice.start();
    this.dataService.getShipmentDetailsByID(id).subscribe(response=>{
      if(response && response.status_code && response.data && response.data.length>0){
        console.log('shipment details',response);
        const shippingData = response.data[0];
        const sampleDetails = shippingData.sample_details?shippingData.sample_details:[];
        let details:{sampleType:string,quantity:number,sampleIds:string}[]=[];
        sampleDetails.forEach((item:any)=>{
          details.push({sampleType:item.sample_id_type,quantity:item.count,sampleIds:item.sample_ids});
        })
        // removing null from address and also adding , and - for chunks...
        const fromAddress = `${shippingData.shipped_from_door_number?shippingData.shipped_from_door_number:""}${shippingData.shipped_from_door_number?",":""}  
        ${shippingData.shipped_from_area?shippingData.shipped_from_area:""}${shippingData.shipped_from_area?",":""} 
        ${shippingData.shipped_from_district?shippingData.shipped_from_district:""}${shippingData.shipped_from_district?",":""}
        ${shippingData.shipped_from_city?shippingData.shipped_from_city:""}${shippingData.shipped_from_city?"-":""} 
        ${shippingData.shipped_from_pin_code?shippingData.shipped_from_pin_code:""}${shippingData.shipped_from_pin_code?",":""} 
        ${shippingData.shipped_from_state?shippingData.shipped_from_state:""}`;
        const toAddress = `${shippingData.shipped_to_door_number?shippingData.shipped_to_door_number:""}${shippingData.shipped_to_door_number?",":""} 
        ${shippingData.shipped_to_area?shippingData.shipped_to_area:""}${shippingData.shipped_to_area?",":""} 
        ${shippingData.shipped_to_district?shippingData.shipped_to_district:""}${shippingData.shipped_to_district?",":""}
        ${shippingData.shipped_to_city?shippingData.shipped_to_city:""}${shippingData.shipped_to_city?"-":""} 
        ${shippingData.shipped_to_pin_code?shippingData.shipped_to_pin_code:""}${shippingData.shipped_to_pin_code?",":""} 
        ${shippingData.shipped_to_state?shippingData.shipped_to_state:""}`;
        this.shipmentDetails= {
            status:shippingData.status,
            id:shippingData.shipment_id,
            location:fromAddress,
            dateOfCreation:shippingData.date_of_shipment_creation,
            shipmentTo:toAddress,
            courierName:shippingData.courier_service,
            trackingNo:shippingData.tracking_number,
            details:details
          };
      }
      this.ngxservice.stop();
    },error=>{
      console.error('error while getting sample details by id',error);
      this.ngxservice.stop();
    })
  }

}
